import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { YandexMapModule } from '@sdvor/yandex-maps/ui';
import { ShopsMapComponent } from './shops-map.component';

@NgModule({
  declarations: [ShopsMapComponent],
  imports: [NgIf, AsyncPipe, YandexMapModule],
  exports: [ShopsMapComponent],
})
export class ShopsMapModule {}
